export const perPro = {
    "[Abl_Mod][1Du]": ["wangkugnek"],
    "[Abl_Mod][1Pl]": ["wangkutnek"],
    "[Abl_Mod][1Sg]": ["wangnek"],
    "[Abl_Mod][2Du]": ["elpetegnek"],
    "[Abl_Mod][2Pl]": ["elpecnek"],
    "[Abl_Mod][2Sg]": ["elpenek"],
    "[Abl_Mod][3Du]": ["elkegnek"],
    "[Abl_Mod][3Pl]": ["ellaitnek"],
    "[Abl_Mod][3Sg]": ["elliinek"],
    "[Abl_Mod][4Du]": ["ellmegnek"],
    "[Abl_Mod][4Pl]": ["ellmeggnek"],
    "[Abl_Mod][4Sg]": ["ellminek"],
    "[Abs][1Du]": ["wangkuk"],
    "[Abs][1Pl]": ["wangkuta"],
    "[Abs][1Sg]": ["wii", "wiinga"],
    "[Abs][2Du]": ["elpetek"],
    "[Abs][2Pl]": ["elpeci"],
    "[Abs][2Sg]": ["elpet"],
    "[Abs][3Du]": ["elkek"],
    "[Abs][3Pl]": ["ellait"],
    "[Abs][3Sg]": ["ellii"],
    "[Abs][4Du]": ["ellmek"],
    "[Abs][4Pl]": ["ellmeng"],
    "[Abs][4Sg]": ["ellmi"],
    "[Equ][1Du]": ["wangkugcetun", "wangkugtun"],
    "[Equ][1Pl]": ["wangkucetun", "wangkutun"],
    "[Equ][1Sg]": ["wangcetun", "wangtun"],
    "[Equ][2Du]": ["elpetegcetun", "elpetegtun"],
    "[Equ][2Pl]": ["elpecicetun", "elpecitun"],
    "[Equ][2Sg]": ["elpecetun", "elpetun"],
    "[Equ][3Du]": ["elkegcetun", "elkegtun"],
    "[Equ][3Pl]": ["ellaicetun", "ellaitun"],
    "[Equ][3Sg]": ["elliicetun", "elliitun"],
    "[Equ][4Du]": ["ellmegnegun"],
    "[Equ][4Pl]": ["ellmegcetun", "ellmegtun"],
    "[Equ][4Sg]": ["ellmicetun", "ellmitun"],
    "[Loc][1Du]": ["wangkugni"],
    "[Loc][1Pl]": ["wangkutni"],
    "[Loc][1Sg]": ["wangni"],
    "[Loc][2Du]": ["elpetegni"],
    "[Loc][2Pl]": ["elpecni"],
    "[Loc][2Sg]": ["elpeni"],
    "[Loc][3Du]": ["elkegni"],
    "[Loc][3Pl]": ["ellaitni"],
    "[Loc][3Sg]": ["elliini"],
    "[Loc][4Du]": ["ellmegni"],
    "[Loc][4Pl]": ["ellmeggni"],
    "[Loc][4Sg]": ["ellmini"],
    "[Rel][1Du]": ["wangkuk"],
    "[Rel][1Pl]": ["wangkuta"],
    "[Rel][1Sg]": ["wii", "wiinga"],
    "[Rel][2Du]": ["elpetek"],
    "[Rel][2Pl]": ["elpeci"],
    "[Rel][2Sg]": ["elpet"],
    "[Rel][3Du]": ["elkenka"],
    "[Rel][3Pl]": ["ellaita"],
    "[Rel][3Sg]": ["elliin"],
    "[Rel][4Du]": ["ellmek"],
    "[Rel][4Pl]": ["ellmeng"],
    "[Rel][4Sg]": ["ellmi"],
    "[Ter][1Du]": ["wangkugnun"],
    "[Ter][1Pl]": ["wangkutnun"],
    "[Ter][1Sg]": ["wangnun"],
    "[Ter][2Du]": ["elpetegnun"],
    "[Ter][2Pl]": ["elpecnun"],
    "[Ter][2Sg]": ["elpenun"],
    "[Ter][3Du]": ["elkegnun"],
    "[Ter][3Pl]": ["ellaitnun"],
    "[Ter][3Sg]": ["elliinun"],
    "[Ter][4Du]": ["ellmegnun"],
    "[Ter][4Pl]": ["ellmeggnun"],
    "[Ter][4Sg]": ["ellminun"],
    "[Via][1Du]": ["wangkugnegun"],
    "[Via][1Pl]": ["wangkutgun"],
    "[Via][1Sg]": ["wangkun"],
    "[Via][2Du]": ["elpetegnegun"],
    "[Via][2Pl]": ["elpecetgun"],
    "[Via][2Sg]": ["elpetgun"],
    "[Via][3Du]": ["elkegnegun"],
    "[Via][3Pl]": ["ellaitgun"],
    "[Via][3Sg]": ["elliikun"],
    "[Via][4Du]": ["ellmegnegun"],
    "[Via][4Pl]": ["ellmegteggun"],
    "[Via][4Sg]": ["ellmikun"]
};

export const demPro = {
    "across there": {
        "extended": {
            "=i[Encl]": ["agaa-i", "ii-i"],
            "[Abl]": ["agaaken", "iiken"],
            "[Abl_Mod][DuUnpd]": ["agkugnek"],
            "[Abl_Mod][PlUnpd]": ["agkunek"],
            "[Abl_Mod][SgUnpd]": ["ag'umek"],
            "[Abs][DuUnpd]": ["agkuk"],
            "[Abs][PlUnpd]": ["agkut"],
            "[Abs][SgUnpd]": ["agna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["agkugcetun"],
            "[Equ][PlUnpd]": ["agkucetun"],
            "[Equ][SgUnpd]": ["ag'utun"],
            "[Loc]": ["agaani", "iini"],
            "[Loc][DuUnpd]": ["agkugni"],
            "[Loc][PlUnpd]": ["agkuni"],
            "[Loc][SgUnpd]": ["ag'umi"],
            "[Rel][DuUnpd]": ["agkuk"],
            "[Rel][PlUnpd]": ["agkut"],
            "[Rel][SgUnpd]": ["ag'um"],
            "[Sec_Ter]": ["agaatmun", "iitmun"],
            "[Ter]": ["agaavet", "iivet"],
            "[Ter][DuUnpd]": ["agkugnun"],
            "[Ter][PlUnpd]": ["agkunun"],
            "[Ter][SgUnpd]": ["ag'umun"],
            "[Via]": ["agaaggun", "iiggun"],
            "[Via][DuUnpd]": ["agkunegnun"],
            "[Via][PlUnpd]": ["agkutgun"],
            "[Via][SgUnpd]": ["ag'ukun"],
            "[Voc][DuUnpd]": ["agkuuk"],
            "[Voc][PlUnpd]": ["agkuut"],
            "[Voc][SgUnpd]": ["agsuuq", "agyuuq"]
        },
        "obscured": {
            "=i[Encl]": ["akma-i"],
            "[Abl]": ["akmaken"],
            "[Abl_Mod][DuUnpd]": ["akemkugnek"],
            "[Abl_Mod][PlUnpd]": ["akemkunek"],
            "[Abl_Mod][SgUnpd]": ["ak'mumek"],
            "[Abs][DuUnpd]": ["akemkuk"],
            "[Abs][PlUnpd]": ["akemkut"],
            "[Abs][SgUnpd]": ["akemna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["akemkugcetun"],
            "[Equ][PlUnpd]": ["akemkucetun"],
            "[Equ][SgUnpd]": ["ak'mutun"],
            "[Loc]": ["akmani"],
            "[Loc][DuUnpd]": ["akemkugni"],
            "[Loc][PlUnpd]": ["akemkuni"],
            "[Loc][SgUnpd]": ["ak'mumi"],
            "[Rel][DuUnpd]": ["akemkuk"],
            "[Rel][PlUnpd]": ["akemkut"],
            "[Rel][SgUnpd]": ["ak'mum"],
            "[Sec_Ter]": ["-"],
            "[Ter]": ["akmavet"],
            "[Ter][DuUnpd]": ["akemkugnun"],
            "[Ter][PlUnpd]": ["akemkunun"],
            "[Ter][SgUnpd]": ["ak'mumun"],
            "[Via]": ["akmaggun"],
            "[Via][DuUnpd]": ["akemkunegnun"],
            "[Via][PlUnpd]": ["akemkutgun"],
            "[Via][SgUnpd]": ["ak'mukun"],
            "[Voc][DuUnpd]": ["akemkuuk"],
            "[Voc][PlUnpd]": ["akemkuut"],
            "[Voc][SgUnpd]": ["akemsuuq", "akemyuuq"]
        },
        "restricted": {
            "=i[Encl]": ["ika-i"],
            "[Abl]": ["ikaken"],
            "[Abl_Mod][DuUnpd]": ["ikegkugnek"],
            "[Abl_Mod][PlUnpd]": ["ikegkunek"],
            "[Abl_Mod][SgUnpd]": ["ik'umek", "ikgumek"],
            "[Abs][DuUnpd]": ["ikegkuk"],
            "[Abs][PlUnpd]": ["ikegkut"],
            "[Abs][SgUnpd]": ["ikna", "ikeggna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["ikegkugcetun"],
            "[Equ][PlUnpd]": ["ikegkucetun"],
            "[Equ][SgUnpd]": ["ik'utun", "ikgutun"],
            "[Loc]": ["ikani"],
            "[Loc][DuUnpd]": ["ikegkugni"],
            "[Loc][PlUnpd]": ["ikegkuni"],
            "[Loc][SgUnpd]": ["ik'umi", "ikgumi"],
            "[Rel][DuUnpd]": ["ikegkuk"],
            "[Rel][PlUnpd]": ["ikegkut"],
            "[Rel][SgUnpd]": ["ik'um", "ikgum"],
            "[Sec_Ter]": ["ikatmun"],
            "[Ter]": ["ikavet"],
            "[Ter][DuUnpd]": ["ikegkugnun"],
            "[Ter][PlUnpd]": ["ikegkunun"],
            "[Ter][SgUnpd]": ["ik'umun", "ikgumun"],
            "[Via]": ["ikaggun"],
            "[Via][DuUnpd]": ["ikegkunegnun"],
            "[Via][PlUnpd]": ["ikegkutgun"],
            "[Via][SgUnpd]": ["ik'ukun", "ikgukun"],
            "[Voc][DuUnpd]": ["ikegkuuk"],
            "[Voc][PlUnpd]": ["ikegkuut"],
            "[Voc][SgUnpd]": ["iksuuq", "ikyuuq", "ikeggsuuq", "ikeggyuuq"]
        }
    },
    "coming this way": {
        "extended": {
            "=i[Encl]": ["uka-i"],
            "[Abl]": ["ukaken"],
            "[Abl_Mod][DuUnpd]": ["ukegkugnek"],
            "[Abl_Mod][PlUnpd]": ["ukegkunek"],
            "[Abl_Mod][SgUnpd]": ["uk'umek"],
            "[Abs][DuUnpd]": ["ukegkuk"],
            "[Abs][PlUnpd]": ["ukegkut"],
            "[Abs][SgUnpd]": ["ukna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["ukegkugcetun"],
            "[Equ][PlUnpd]": ["ukegkucetun"],
            "[Equ][SgUnpd]": ["uk'utun"],
            "[Loc]": ["ukani"],
            "[Loc][DuUnpd]": ["ukegkugni"],
            "[Loc][PlUnpd]": ["ukegkuni"],
            "[Loc][SgUnpd]": ["uk'umi"],
            "[Rel][DuUnpd]": ["ukegkuk"],
            "[Rel][PlUnpd]": ["ukegkut"],
            "[Rel][SgUnpd]": ["uk'um"],
            "[Sec_Ter]": ["ukatmun"],
            "[Ter]": ["ukavet"],
            "[Ter][DuUnpd]": ["ukegkugnun"],
            "[Ter][PlUnpd]": ["ukegkunun"],
            "[Ter][SgUnpd]": ["uk'umun"],
            "[Via]": ["ukaggun"],
            "[Via][DuUnpd]": ["ukegkunegnun"],
            "[Via][PlUnpd]": ["ukegkutgun"],
            "[Via][SgUnpd]": ["uk'ukun"],
            "[Voc][DuUnpd]": ["ukegkuuk"],
            "[Voc][PlUnpd]": ["ukegkuut"],
            "[Voc][SgUnpd]": ["uksuuq", "ukyuuq"]
        }
    },
    "down below or down the slope": {
        "extended": {
            "=i[Encl]": ["una-i"],
            "[Abl]": ["unaken"],
            "[Abl_Mod][DuUnpd]": ["unkugnek"],
            "[Abl_Mod][PlUnpd]": ["unkunek"],
            "[Abl_Mod][SgUnpd]": ["un'umek"],
            "[Abs][DuUnpd]": ["unkuk"],
            "[Abs][PlUnpd]": ["unkut"],
            "[Abs][SgUnpd]": ["un'a"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["unkugcetun"],
            "[Equ][PlUnpd]": ["unkucetun"],
            "[Equ][SgUnpd]": ["un'utun"],
            "[Loc]": ["unani"],
            "[Loc][DuUnpd]": ["unkugni"],
            "[Loc][PlUnpd]": ["unkuni"],
            "[Loc][SgUnpd]": ["un'umi"],
            "[Rel][DuUnpd]": ["unkuk"],
            "[Rel][PlUnpd]": ["unkut"],
            "[Rel][SgUnpd]": ["un'um"],
            "[Sec_Ter]": ["unatmun"],
            "[Ter]": ["unavet"],
            "[Ter][DuUnpd]": ["unkugnun"],
            "[Ter][PlUnpd]": ["unkunun"],
            "[Ter][SgUnpd]": ["un'umun"],
            "[Via]": ["unaggun"],
            "[Via][DuUnpd]": ["unkunegnun"],
            "[Via][PlUnpd]": ["unkutgun"],
            "[Via][SgUnpd]": ["un'ukun"],
            "[Voc][DuUnpd]": ["unkuuk"],
            "[Voc][PlUnpd]": ["unkuut"],
            "[Voc][SgUnpd]": ["unsuuq", "unyuuq"]
        },
        "obscured": {
            "=i[Encl]": ["cama-i"],
            "[Abl]": ["camaken"],
            "[Abl_Mod][DuUnpd]": ["camkugnek"],
            "[Abl_Mod][PlUnpd]": ["camkunek"],
            "[Abl_Mod][SgUnpd]": ["cam'umek"],
            "[Abs][DuUnpd]": ["camkuk"],
            "[Abs][PlUnpd]": ["camkut"],
            "[Abs][SgUnpd]": ["camna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["camkugcetun"],
            "[Equ][PlUnpd]": ["camkucetun"],
            "[Equ][SgUnpd]": ["cam'utun"],
            "[Loc]": ["camani"],
            "[Loc][DuUnpd]": ["camkugni"],
            "[Loc][PlUnpd]": ["camkuni"],
            "[Loc][SgUnpd]": ["cam'umi"],
            "[Rel][DuUnpd]": ["camkuk"],
            "[Rel][PlUnpd]": ["camkut"],
            "[Rel][SgUnpd]": ["cam'um"],
            "[Sec_Ter]": ["-"],
            "[Ter]": ["camavet"],
            "[Ter][DuUnpd]": ["camkugnun"],
            "[Ter][PlUnpd]": ["camkunun"],
            "[Ter][SgUnpd]": ["cam'umun"],
            "[Via]": ["camaggun"],
            "[Via][DuUnpd]": ["camkunegnun"],
            "[Via][PlUnpd]": ["camkutgun"],
            "[Via][SgUnpd]": ["cam'ukun"],
            "[Voc][DuUnpd]": ["camkuuk"],
            "[Voc][PlUnpd]": ["camkuut"],
            "[Voc][SgUnpd]": ["camsuuq", "camyuuq"]
        },
        "restricted": {
            "=i[Encl]": ["kana-i"],
            "[Abl]": ["kanaken"],
            "[Abl_Mod][DuUnpd]": ["kankugnek"],
            "[Abl_Mod][PlUnpd]": ["kankunek"],
            "[Abl_Mod][SgUnpd]": ["kat'umek"],
            "[Abs][DuUnpd]": ["kankuk"],
            "[Abs][PlUnpd]": ["kankut"],
            "[Abs][SgUnpd]": ["kan'a"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["kankugcetun"],
            "[Equ][PlUnpd]": ["kankucetun"],
            "[Equ][SgUnpd]": ["kat'utun"],
            "[Loc]": ["kanani"],
            "[Loc][DuUnpd]": ["kankugni"],
            "[Loc][PlUnpd]": ["kankuni"],
            "[Loc][SgUnpd]": ["kat'umi"],
            "[Rel][DuUnpd]": ["kankuk"],
            "[Rel][PlUnpd]": ["kankut"],
            "[Rel][SgUnpd]": ["kat'um"],
            "[Sec_Ter]": ["kanatmun"],
            "[Ter]": ["kanavet"],
            "[Ter][DuUnpd]": ["kankugnun"],
            "[Ter][PlUnpd]": ["kankunun"],
            "[Ter][SgUnpd]": ["kat'umun"],
            "[Via]": ["kanaggun"],
            "[Via][DuUnpd]": ["kankunegnun"],
            "[Via][PlUnpd]": ["kankutgun"],
            "[Via][SgUnpd]": ["kat'ukun"],
            "[Voc][DuUnpd]": ["kankuuk"],
            "[Voc][PlUnpd]": ["kankuut"],
            "[Voc][SgUnpd]": ["kacuuq"]
        }
    },
    "downriver or near the exit": {
        "extended": {
            "=i[Encl]": ["un'ga-i", "un'gaa-i"],
            "[Abl]": ["un'gaken", "un'gaaken"],
            "[Abl_Mod][DuUnpd]": ["unegkugnek"],
            "[Abl_Mod][PlUnpd]": ["unegkunek"],
            "[Abl_Mod][SgUnpd]": ["ung'umek"],
            "[Abs][DuUnpd]": ["unegkuk"],
            "[Abs][PlUnpd]": ["unegkut"],
            "[Abs][SgUnpd]": ["unegna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["unegkugcetun"],
            "[Equ][PlUnpd]": ["unegkucetun"],
            "[Equ][SgUnpd]": ["ung'utun"],
            "[Loc]": ["un'gani", "un'gaani"],
            "[Loc][DuUnpd]": ["unegkugni"],
            "[Loc][PlUnpd]": ["unegkuni"],
            "[Loc][SgUnpd]": ["ung'umi"],
            "[Rel][DuUnpd]": ["unegkuk"],
            "[Rel][PlUnpd]": ["unegkut"],
            "[Rel][SgUnpd]": ["ung'um"],
            "[Sec_Ter]": ["un'gatmun", "un'gaatmun"],
            "[Ter]": ["un'gavet", "un'gaavet"],
            "[Ter][DuUnpd]": ["unegkugnun"],
            "[Ter][PlUnpd]": ["unegkunun"],
            "[Ter][SgUnpd]": ["ung'umun"],
            "[Via]": ["un'gaggun", "un'gaaggun"],
            "[Via][DuUnpd]": ["unegkunegnun"],
            "[Via][PlUnpd]": ["unegkutgun"],
            "[Via][SgUnpd]": ["ung'ukun"],
            "[Voc][DuUnpd]": ["unegkuuk"],
            "[Voc][PlUnpd]": ["unegkuut"],
            "[Voc][SgUnpd]": ["unegsuuq", "unegyuuq"]
        },
        "obscured": {
            "=i[Encl]": ["cakma-i"],
            "[Abl]": ["cakmaken"],
            "[Abl_Mod][DuUnpd]": ["cakemkugnek"],
            "[Abl_Mod][PlUnpd]": ["cakemkunek"],
            "[Abl_Mod][SgUnpd]": ["cak'mumek"],
            "[Abs][DuUnpd]": ["cakemkuk"],
            "[Abs][PlUnpd]": ["cakemkut"],
            "[Abs][SgUnpd]": ["cakemna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["cakemkugcetun"],
            "[Equ][PlUnpd]": ["cakemkucetun"],
            "[Equ][SgUnpd]": ["cak'mutun"],
            "[Loc]": ["cakmani"],
            "[Loc][DuUnpd]": ["cakemkugni"],
            "[Loc][PlUnpd]": ["cakemkuni"],
            "[Loc][SgUnpd]": ["cak'mumi"],
            "[Rel][DuUnpd]": ["cakemkuk"],
            "[Rel][PlUnpd]": ["cakemkut"],
            "[Rel][SgUnpd]": ["cak'mum"],
            "[Sec_Ter]": ["-"],
            "[Ter]": ["cakmavet"],
            "[Ter][DuUnpd]": ["cakemkugnun"],
            "[Ter][PlUnpd]": ["cakemkunun"],
            "[Ter][SgUnpd]": ["cak'mumun"],
            "[Via]": ["cakmaggun"],
            "[Via][DuUnpd]": ["cakemkunegnun"],
            "[Via][PlUnpd]": ["cakemkutgun"],
            "[Via][SgUnpd]": ["cak'mukun"],
            "[Voc][DuUnpd]": ["cakemkuuk"],
            "[Voc][PlUnpd]": ["cakemkuut"],
            "[Voc][SgUnpd]": ["cakemsuuq", "cakemyuuq"]
        },
        "restricted": {
            "=i[Encl]": ["ua-i"],
            "[Abl]": ["uaken"],
            "[Abl_Mod][DuUnpd]": ["ugkugnek"],
            "[Abl_Mod][PlUnpd]": ["ugkunek"],
            "[Abl_Mod][SgUnpd]": ["ug'umek"],
            "[Abs][DuUnpd]": ["ugkuk"],
            "[Abs][PlUnpd]": ["ugkut"],
            "[Abs][SgUnpd]": ["ugna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["ugkugcetun"],
            "[Equ][PlUnpd]": ["ugkucetun"],
            "[Equ][SgUnpd]": ["ug'utun"],
            "[Loc]": ["uani"],
            "[Loc][DuUnpd]": ["ugkugni"],
            "[Loc][PlUnpd]": ["ugkuni"],
            "[Loc][SgUnpd]": ["ug'umi"],
            "[Rel][DuUnpd]": ["ugkuk"],
            "[Rel][PlUnpd]": ["ugkut"],
            "[Rel][SgUnpd]": ["ug'um"],
            "[Sec_Ter]": ["uatmun"],
            "[Ter]": ["uavet"],
            "[Ter][DuUnpd]": ["ugkugnun"],
            "[Ter][PlUnpd]": ["ugkunun"],
            "[Ter][SgUnpd]": ["ug'umun"],
            "[Via]": ["uaggun"],
            "[Via][DuUnpd]": ["ugkunegnun"],
            "[Via][PlUnpd]": ["ugkutgun"],
            "[Via][SgUnpd]": ["ug'ukun"],
            "[Voc][DuUnpd]": ["ugkuuk"],
            "[Voc][PlUnpd]": ["ugkuut"],
            "[Voc][SgUnpd]": ["ugsuuq", "ugyuuq"]
        }
    },
    "here, near speaker": {
        "extended": {
            "=i[Encl]": ["maa-i"],
            "[Abl]": ["maaken"],
            "[Abl_Mod][DuUnpd]": ["makugnek"],
            "[Abl_Mod][PlUnpd]": ["makunek"],
            "[Abl_Mod][SgUnpd]": ["mat'umek"],
            "[Abs][DuUnpd]": ["makuk"],
            "[Abs][PlUnpd]": ["makut"],
            "[Abs][SgUnpd]": ["man'a"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["makugcetun"],
            "[Equ][PlUnpd]": ["makucetun"],
            "[Equ][SgUnpd]": ["mat'utun"],
            "[Loc]": ["maani"],
            "[Loc][DuUnpd]": ["makugni"],
            "[Loc][PlUnpd]": ["makuni"],
            "[Loc][SgUnpd]": ["mat'umi"],
            "[Rel][DuUnpd]": ["makuk"],
            "[Rel][PlUnpd]": ["makut"],
            "[Rel][SgUnpd]": ["mat'um"],
            "[Sec_Ter]": ["maatmun"],
            "[Ter]": ["maavet"],
            "[Ter][DuUnpd]": ["makugnun"],
            "[Ter][PlUnpd]": ["makunun"],
            "[Ter][SgUnpd]": ["mat'umun"],
            "[Via]": ["maaggun"],
            "[Via][DuUnpd]": ["makunegnun"],
            "[Via][PlUnpd]": ["makutgun"],
            "[Via][SgUnpd]": ["mat'ukun"],
            "[Voc][DuUnpd]": ["makuuk"],
            "[Voc][PlUnpd]": ["makuut"],
            "[Voc][SgUnpd]": ["macuuq"]
        },
        "obscured": {
            "=i[Encl]": ["ima-i"],
            "[Abl]": ["imaken"],
            "[Abl_Mod][DuUnpd]": ["imkugnek"],
            "[Abl_Mod][PlUnpd]": ["imkunek"],
            "[Abl_Mod][SgUnpd]": ["im'umek", "imumek"],
            "[Abs][DuUnpd]": ["imkuk"],
            "[Abs][PlUnpd]": ["imkut"],
            "[Abs][SgUnpd]": ["imna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["imkugcetun"],
            "[Equ][PlUnpd]": ["imkucetun"],
            "[Equ][SgUnpd]": ["im'utun", "imutun"],
            "[Loc]": ["imani"],
            "[Loc][DuUnpd]": ["imkugni"],
            "[Loc][PlUnpd]": ["imkuni"],
            "[Loc][SgUnpd]": ["im'umi", "imumi"],
            "[Rel][DuUnpd]": ["imkuk"],
            "[Rel][PlUnpd]": ["imkut"],
            "[Rel][SgUnpd]": ["im'um", "imum"],
            "[Sec_Ter]": ["-"],
            "[Ter]": ["imavet"],
            "[Ter][DuUnpd]": ["imkugnun"],
            "[Ter][PlUnpd]": ["imkunun"],
            "[Ter][SgUnpd]": ["im'umun", "imumun"],
            "[Via]": ["imaggun"],
            "[Via][DuUnpd]": ["imkunegnun"],
            "[Via][PlUnpd]": ["imkutgun"],
            "[Via][SgUnpd]": ["im'ukun", "imukun"],
            "[Voc][DuUnpd]": ["imkuuk"],
            "[Voc][PlUnpd]": ["imkuut"],
            "[Voc][SgUnpd]": ["imsuuq", "imyuuq"]
        },
        "restricted": {
            "=i[Encl]": ["wani-wa"],
            "[Abl]": ["waken"],
            "[Abl_Mod][DuUnpd]": ["ukugnek"],
            "[Abl_Mod][PlUnpd]": ["ukunek"],
            "[Abl_Mod][SgUnpd]": ["uumek"],
            "[Abs][DuUnpd]": ["ukuk"],
            "[Abs][PlUnpd]": ["ukut"],
            "[Abs][SgUnpd]": ["una"],
            "[Equ]": ["waten"],
            "[Equ][DuUnpd]": ["ukugcetun"],
            "[Equ][PlUnpd]": ["ukucetun"],
            "[Equ][SgUnpd]": ["uutun"],
            "[Loc]": ["wani"],
            "[Loc][DuUnpd]": ["ukugni"],
            "[Loc][PlUnpd]": ["ukuni"],
            "[Loc][SgUnpd]": ["uumi"],
            "[Rel][DuUnpd]": ["ukuk"],
            "[Rel][PlUnpd]": ["ukut"],
            "[Rel][SgUnpd]": ["uum"],
            "[Sec_Ter]": ["-"],
            "[Ter]": ["wavet"],
            "[Ter][DuUnpd]": ["ukugnun"],
            "[Ter][PlUnpd]": ["ukunun"],
            "[Ter][SgUnpd]": ["uumun"],
            "[Via]": ["uuggun", "waggun"],
            "[Via][DuUnpd]": ["ukunegnun"],
            "[Via][PlUnpd]": ["ukutgun"],
            "[Via][SgUnpd]": ["uukun", "uuggun"],
            "[Voc][DuUnpd]": ["ukuuk"],
            "[Voc][PlUnpd]": ["ukuut"],
            "[Voc][SgUnpd]": ["usuuq", "uyuuq"]
        }
    },
    "inside, inland, or upriver": {
        "extended": {
            "=i[Encl]": ["qava-i"],
            "[Abl]": ["qavaken"],
            "[Abl_Mod][DuUnpd]": ["qau͡gkugnek", "qaugkugnek"],
            "[Abl_Mod][PlUnpd]": ["qau͡gkunek", "qaugkunek"],
            "[Abl_Mod][SgUnpd]": ["qau͡g'umek", "qaug'umek"],
            "[Abs][DuUnpd]": ["qau͡gkuk", "qaugkuk"],
            "[Abs][PlUnpd]": ["qau͡gkut", "qaugkut"],
            "[Abs][SgUnpd]": ["qau͡gna", "qaugna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["qau͡gkugcetun", "qaugkugcetun"],
            "[Equ][PlUnpd]": ["qau͡gkucetun", "qaugkucetun"],
            "[Equ][SgUnpd]": ["qau͡g'utun", "qaug'utun"],
            "[Loc]": ["qavani"],
            "[Loc][DuUnpd]": ["qau͡gkugni", "qaugkugni"],
            "[Loc][PlUnpd]": ["qau͡gkuni", "qaugkuni"],
            "[Loc][SgUnpd]": ["qau͡g'umi", "qaug'umi"],
            "[Rel][DuUnpd]": ["qau͡gkuk", "qaugkuk"],
            "[Rel][PlUnpd]": ["qau͡gkut", "qaugkut"],
            "[Rel][SgUnpd]": ["qau͡g'um", "qaug'um"],
            "[Sec_Ter]": ["qavatmun"],
            "[Ter]": ["qavavet"],
            "[Ter][DuUnpd]": ["qau͡gkugnun", "qaugkugnun"],
            "[Ter][PlUnpd]": ["qau͡gkunun", "qaugkunun"],
            "[Ter][SgUnpd]": ["qau͡g'umun", "qaug'umun"],
            "[Via]": ["qavaggun"],
            "[Via][DuUnpd]": ["qau͡gkunegnun", "qaugkunegnun"],
            "[Via][PlUnpd]": ["qau͡gkutgun", "qaugkutgun"],
            "[Via][SgUnpd]": ["qau͡g'ukun", "qaug'ukun"],
            "[Voc][DuUnpd]": ["qau͡gkuuk", "qaugkuuk"],
            "[Voc][PlUnpd]": ["qau͡gkuut", "qaugkuut"],
            "[Voc][SgUnpd]": ["qaugsuuq", "qaugyuuq", "qau͡gsuuq", "qau͡gyuuq"]
        },
        "obscured": {
            "=i[Encl]": ["qama-i"],
            "[Abl]": ["qamaken"],
            "[Abl_Mod][DuUnpd]": ["qamkugnek"],
            "[Abl_Mod][PlUnpd]": ["qamkunek"],
            "[Abl_Mod][SgUnpd]": ["qam'umek"],
            "[Abs][DuUnpd]": ["qamkuk"],
            "[Abs][PlUnpd]": ["qamkut"],
            "[Abs][SgUnpd]": ["qamna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["qamkugcetun"],
            "[Equ][PlUnpd]": ["qamkucetun"],
            "[Equ][SgUnpd]": ["qam'utun"],
            "[Loc]": ["qamani"],
            "[Loc][DuUnpd]": ["qamkugni"],
            "[Loc][PlUnpd]": ["qamkuni"],
            "[Loc][SgUnpd]": ["qam'umi"],
            "[Rel][DuUnpd]": ["qamkuk"],
            "[Rel][PlUnpd]": ["qamkut"],
            "[Rel][SgUnpd]": ["qam'um"],
            "[Sec_Ter]": ["-"],
            "[Ter]": ["qamavet"],
            "[Ter][DuUnpd]": ["qamkugnun"],
            "[Ter][PlUnpd]": ["qamkunun"],
            "[Ter][SgUnpd]": ["qam'umun"],
            "[Via]": ["qamaggun"],
            "[Via][DuUnpd]": ["qamkunegnun"],
            "[Via][PlUnpd]": ["qamkutgun"],
            "[Via][SgUnpd]": ["qam'ukun"],
            "[Voc][DuUnpd]": ["qamkuuk"],
            "[Voc][PlUnpd]": ["qamkuut"],
            "[Voc][SgUnpd]": ["qamsuuq", "qamyuuq"]
        },
        "restricted": {
            "=i[Encl]": ["kia-i"],
            "[Abl]": ["kiaken"],
            "[Abl_Mod][DuUnpd]": ["kiu͡gkugnek", "kiugkugnek"],
            "[Abl_Mod][PlUnpd]": ["kiu͡gkunek", "kiugkunek"],
            "[Abl_Mod][SgUnpd]": ["kiu͡g'umek", "kiug'umek", "kiugumek"],
            "[Abs][DuUnpd]": ["kiu͡gkuk", "kiugkuk"],
            "[Abs][PlUnpd]": ["kiu͡gkut", "kiugkut"],
            "[Abs][SgUnpd]": ["kiu͡gna", "kiugna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["kiu͡gkugcetun", "kiugkugcetun"],
            "[Equ][PlUnpd]": ["kiu͡gkucetun", "kiugkucetun"],
            "[Equ][SgUnpd]": ["kiu͡g'utun", "kiug'utun", "kiugutun"],
            "[Loc]": ["kiani"],
            "[Loc][DuUnpd]": ["kiu͡gkugni", "kiugkugni"],
            "[Loc][PlUnpd]": ["kiu͡gkuni", "kiugkuni"],
            "[Loc][SgUnpd]": ["kiu͡g'umi", "kiug'umi", "kiugumi"],
            "[Rel][DuUnpd]": ["kiu͡gkuk", "kiugkuk"],
            "[Rel][PlUnpd]": ["kiu͡gkut", "kiugkut"],
            "[Rel][SgUnpd]": ["kiu͡g'um", "kiugum", "kiug'um"],
            "[Sec_Ter]": ["kiatmun"],
            "[Ter]": ["kiavet"],
            "[Ter][DuUnpd]": ["kiu͡gkugnun", "kiugkugnun"],
            "[Ter][PlUnpd]": ["kiu͡gkunun", "kiugkunun"],
            "[Ter][SgUnpd]": ["kiu͡g'umun", "kiug'umun", "kiugumun"],
            "[Via]": ["kiaggun"],
            "[Via][DuUnpd]": ["kiu͡gkunegnun", "kiugkunegnun"],
            "[Via][PlUnpd]": ["kiu͡gkutgun", "kiugkutgun"],
            "[Via][SgUnpd]": ["kiu͡g'ukun", "kiug'ukun", "kiugukun"],
            "[Voc][DuUnpd]": ["kiu͡gkuuk", "kiugkuuk"],
            "[Voc][PlUnpd]": ["kiu͡gkuut", "kiugkuut"],
            "[Voc][SgUnpd]": ["kiu͡gsuuq", "kiu͡gyuuq", "kiugsuuq", "kiugyuuq"]
        }
    },
    "outside": {
        "extended": {
            "=i[Encl]": ["qagaa-i", "qii-i"],
            "[Abl]": ["qagaaken", "qiiken"],
            "[Abl_Mod][DuUnpd]": ["qagkugnek"],
            "[Abl_Mod][PlUnpd]": ["qagkunek"],
            "[Abl_Mod][SgUnpd]": ["qag'umek"],
            "[Abs][DuUnpd]": ["qagkuk"],
            "[Abs][PlUnpd]": ["qagkut"],
            "[Abs][SgUnpd]": ["qagna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["qagkugcetun"],
            "[Equ][PlUnpd]": ["qagkucetun"],
            "[Equ][SgUnpd]": ["qag'utun"],
            "[Loc]": ["qagaani", "qiini"],
            "[Loc][DuUnpd]": ["qagkugni"],
            "[Loc][PlUnpd]": ["qagkuni"],
            "[Loc][SgUnpd]": ["qag'umi"],
            "[Rel][DuUnpd]": ["qagkuk"],
            "[Rel][PlUnpd]": ["qagkut"],
            "[Rel][SgUnpd]": ["qag'um"],
            "[Sec_Ter]": ["qagaatmun", "qiitmun"],
            "[Ter]": ["qagaavet", "qiivet"],
            "[Ter][DuUnpd]": ["qagkugnun"],
            "[Ter][PlUnpd]": ["qagkunun"],
            "[Ter][SgUnpd]": ["qag'umun"],
            "[Via]": ["qagaaggun", "qiiggun"],
            "[Via][DuUnpd]": ["qagkunegnun"],
            "[Via][PlUnpd]": ["qagkutgun"],
            "[Via][SgUnpd]": ["qag'ukun"],
            "[Voc][DuUnpd]": ["qagkuuk"],
            "[Voc][PlUnpd]": ["qagkuut"],
            "[Voc][SgUnpd]": ["qagsuuq", "qagyuuq"]
        },
        "obscured": {
            "=i[Encl]": ["qakma-i"],
            "[Abl]": ["qakmaken"],
            "[Abl_Mod][DuUnpd]": ["qakemkugnek"],
            "[Abl_Mod][PlUnpd]": ["qakemkunek"],
            "[Abl_Mod][SgUnpd]": ["qak'mumek"],
            "[Abs][DuUnpd]": ["qakemkuk"],
            "[Abs][PlUnpd]": ["qakemkut"],
            "[Abs][SgUnpd]": ["qakemna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["qakemkugcetun"],
            "[Equ][PlUnpd]": ["qakemkucetun"],
            "[Equ][SgUnpd]": ["qak'mutun"],
            "[Loc]": ["qakmani"],
            "[Loc][DuUnpd]": ["qakemkugni"],
            "[Loc][PlUnpd]": ["qakemkuni"],
            "[Loc][SgUnpd]": ["qak'mumi"],
            "[Rel][DuUnpd]": ["qakemkuk"],
            "[Rel][PlUnpd]": ["qakemkut"],
            "[Rel][SgUnpd]": ["qak'mum"],
            "[Sec_Ter]": ["-"],
            "[Ter]": ["qakmavet"],
            "[Ter][DuUnpd]": ["qakemkugnun"],
            "[Ter][PlUnpd]": ["qakemkunun"],
            "[Ter][SgUnpd]": ["qak'mumun"],
            "[Via]": ["qakmaggun"],
            "[Via][DuUnpd]": ["qakemkunegnun"],
            "[Via][PlUnpd]": ["qakemkutgun"],
            "[Via][SgUnpd]": ["qak'mukun"],
            "[Voc][DuUnpd]": ["qakemkuuk"],
            "[Voc][PlUnpd]": ["qakemkuut"],
            "[Voc][SgUnpd]": ["qakemsuuq", "qakemyuuq"]
        },
        "restricted": {
            "=i[Encl]": ["kegga-i"],
            "[Abl]": ["keggaken"],
            "[Abl_Mod][DuUnpd]": ["kegkugnek"],
            "[Abl_Mod][PlUnpd]": ["kegkunek"],
            "[Abl_Mod][SgUnpd]": ["kegg'umek"],
            "[Abs][DuUnpd]": ["kegkuk"],
            "[Abs][PlUnpd]": ["kegkut"],
            "[Abs][SgUnpd]": ["keggna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["kegkugcetun"],
            "[Equ][PlUnpd]": ["kegkucetun"],
            "[Equ][SgUnpd]": ["kegg'utun"],
            "[Loc]": ["keggani"],
            "[Loc][DuUnpd]": ["kegkugni"],
            "[Loc][PlUnpd]": ["kegkuni"],
            "[Loc][SgUnpd]": ["kegg'umi"],
            "[Rel][DuUnpd]": ["kegkuk"],
            "[Rel][PlUnpd]": ["kegkut"],
            "[Rel][SgUnpd]": ["kegg'um"],
            "[Sec_Ter]": ["keggatmun"],
            "[Ter]": ["keggavet"],
            "[Ter][DuUnpd]": ["kegkugnun"],
            "[Ter][PlUnpd]": ["kegkunun"],
            "[Ter][SgUnpd]": ["kegg'umun"],
            "[Via]": ["keggaggun"],
            "[Via][DuUnpd]": ["kegkunegnun"],
            "[Via][PlUnpd]": ["kegkutgun"],
            "[Via][SgUnpd]": ["kegg'ukun"],
            "[Voc][DuUnpd]": ["kegkuuk"],
            "[Voc][PlUnpd]": ["kegkuut"],
            "[Voc][SgUnpd]": ["keggsuuq", "keggyuuq"]
        }
    },
    "over there or going away": {
        "extended": {
            "=i[Encl]": ["ava-i"],
            "[Abl]": ["avaken"],
            "[Abl_Mod][DuUnpd]": ["au͡gkugnek", "augkugnek", "awkugnek"],
            "[Abl_Mod][PlUnpd]": ["au͡gkunek", "augkunek", "awkunek"],
            "[Abl_Mod][SgUnpd]": ["au͡g'umek", "aug'umek"],
            "[Abs][DuUnpd]": ["au͡gkuk", "augkuk", "awkuk"],
            "[Abs][PlUnpd]": ["au͡gkut", "augkut", "awkut"],
            "[Abs][SgUnpd]": ["au͡gna", "augna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["au͡gkugcetun", "augkugcetun", "awkugcetun"],
            "[Equ][PlUnpd]": ["au͡gkucetun", "augkucetun", "awkucetun"],
            "[Equ][SgUnpd]": ["au͡g'utun", "aug'utun"],
            "[Loc]": ["avani"],
            "[Loc][DuUnpd]": ["au͡gkugni", "augkugni", "awkugni"],
            "[Loc][PlUnpd]": ["au͡gkuni", "augkuni", "awkuni"],
            "[Loc][SgUnpd]": ["au͡g'umi", "aug'umi"],
            "[Rel][DuUnpd]": ["au͡gkuk", "augkuk", "awkuk"],
            "[Rel][PlUnpd]": ["au͡gkut", "augkut", "awkut"],
            "[Rel][SgUnpd]": ["au͡g'um", "aug'um"],
            "[Sec_Ter]": ["avatmun"],
            "[Ter]": ["avavet"],
            "[Ter][DuUnpd]": ["au͡gkugnun", "augkugnun", "awkugnun"],
            "[Ter][PlUnpd]": ["au͡gkunun", "augkunun", "awkunun"],
            "[Ter][SgUnpd]": ["au͡g'umun", "aug'umun"],
            "[Via]": ["avaggun"],
            "[Via][DuUnpd]": ["au͡gkunegnun", "augkunegnun", "awkunegnun"],
            "[Via][PlUnpd]": ["au͡gkutgun", "augkutgun", "awkutgun"],
            "[Via][SgUnpd]": ["au͡g'ukun", "aug'ukun"],
            "[Voc][DuUnpd]": ["au͡gkuuk", "augkuuk", "awkuuk"],
            "[Voc][PlUnpd]": ["au͡gkuut", "augkuut", "awkuut"],
            "[Voc][SgUnpd]": ["au͡gsuuq", "au͡gyuuq", "augsuuq", "augyuuq"]
        },
        "obscured": {
            "=i[Encl]": ["ama-i"],
            "[Abl]": ["amaken"],
            "[Abl_Mod][DuUnpd]": ["amkugnek"],
            "[Abl_Mod][PlUnpd]": ["amkunek"],
            "[Abl_Mod][SgUnpd]": ["am'umek"],
            "[Abs][DuUnpd]": ["amkuk"],
            "[Abs][PlUnpd]": ["amkut"],
            "[Abs][SgUnpd]": ["amna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["amkugcetun"],
            "[Equ][PlUnpd]": ["amkucetun"],
            "[Equ][SgUnpd]": ["am'utun"],
            "[Loc]": ["amani"],
            "[Loc][DuUnpd]": ["amkugni"],
            "[Loc][PlUnpd]": ["amkuni"],
            "[Loc][SgUnpd]": ["am'umi"],
            "[Rel][DuUnpd]": ["amkuk"],
            "[Rel][PlUnpd]": ["amkut"],
            "[Rel][SgUnpd]": ["am'um"],
            "[Sec_Ter]": ["-"],
            "[Ter]": ["amavet"],
            "[Ter][DuUnpd]": ["amkugnun"],
            "[Ter][PlUnpd]": ["amkunun"],
            "[Ter][SgUnpd]": ["am'umun"],
            "[Via]": ["amaggun"],
            "[Via][DuUnpd]": ["amkunegnun"],
            "[Via][PlUnpd]": ["amkutgun"],
            "[Via][SgUnpd]": ["am'ukun"],
            "[Voc][DuUnpd]": ["amkuuk"],
            "[Voc][PlUnpd]": ["amkuut"],
            "[Voc][SgUnpd]": ["amsuuq", "amyuuq"]
        },
        "restricted": {
            "=i[Encl]": ["yaa-i"],
            "[Abl]": ["yaaken"],
            "[Abl_Mod][DuUnpd]": ["ingkugnek"],
            "[Abl_Mod][PlUnpd]": ["ingkunek"],
            "[Abl_Mod][SgUnpd]": ["ing'umek"],
            "[Abs][DuUnpd]": ["ingkuk"],
            "[Abs][PlUnpd]": ["ingkut"],
            "[Abs][SgUnpd]": ["ingna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["ingkugcetun"],
            "[Equ][PlUnpd]": ["ingkucetun"],
            "[Equ][SgUnpd]": ["ing'utun"],
            "[Loc]": ["yaani"],
            "[Loc][DuUnpd]": ["ingkugni"],
            "[Loc][PlUnpd]": ["ingkuni"],
            "[Loc][SgUnpd]": ["ing'umi"],
            "[Rel][DuUnpd]": ["ingkuk"],
            "[Rel][PlUnpd]": ["ingkut"],
            "[Rel][SgUnpd]": ["ing'um"],
            "[Sec_Ter]": ["yaatmun"],
            "[Ter]": ["yaavet"],
            "[Ter][DuUnpd]": ["ingkugnun"],
            "[Ter][PlUnpd]": ["ingkunun"],
            "[Ter][SgUnpd]": ["ing'umun"],
            "[Via]": ["yaaggun"],
            "[Via][DuUnpd]": ["ingkunegnun"],
            "[Via][PlUnpd]": ["ingkutgun"],
            "[Via][SgUnpd]": ["ing'ukun"],
            "[Voc][DuUnpd]": ["ingkuuk"],
            "[Voc][PlUnpd]": ["ingkuut"],
            "[Voc][SgUnpd]": ["ingsuuq", "ingyuuq"]
        }
    },
    "there, near listener or in context": {
        "extended": {
            "=i[Encl]": ["tamaa-i"],
            "[Abl]": ["tamaaken"],
            "[Abl_Mod][DuUnpd]": ["tamakugnek"],
            "[Abl_Mod][PlUnpd]": ["tamakunek"],
            "[Abl_Mod][SgUnpd]": ["tamatumek"],
            "[Abs][DuUnpd]": ["tamakuk"],
            "[Abs][PlUnpd]": ["tamakut"],
            "[Abs][SgUnpd]": ["tamana"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["tamakugcetun"],
            "[Equ][PlUnpd]": ["tamakucetun"],
            "[Equ][SgUnpd]": ["tamatutun"],
            "[Loc]": ["tamaani"],
            "[Loc][DuUnpd]": ["tamakugni"],
            "[Loc][PlUnpd]": ["tamakuni"],
            "[Loc][SgUnpd]": ["tamatumi"],
            "[Rel][DuUnpd]": ["tamakuk"],
            "[Rel][PlUnpd]": ["tamakut"],
            "[Rel][SgUnpd]": ["tamatum"],
            "[Sec_Ter]": ["tamaatmun"],
            "[Ter]": ["tamaavet"],
            "[Ter][DuUnpd]": ["tamakugnun"],
            "[Ter][PlUnpd]": ["tamakunun"],
            "[Ter][SgUnpd]": ["tamatumun"],
            "[Via]": ["tamaaggun"],
            "[Via][DuUnpd]": ["tamakunegnun"],
            "[Via][PlUnpd]": ["tamakutgun"],
            "[Via][SgUnpd]": ["tamatukun"],
            "[Voc][DuUnpd]": ["tamakuuk"],
            "[Voc][PlUnpd]": ["tamakuut"],
            "[Voc][SgUnpd]": ["tamasuuq", "tamayuuq"]
        },
        "restricted": {
            "=i[Encl]": ["tua-i", "tava-i"],
            "[Abl]": ["tuaken", "tavaken"],
            "[Abl_Mod][DuUnpd]": ["taukugnek"],
            "[Abl_Mod][PlUnpd]": ["taukunek"],
            "[Abl_Mod][SgUnpd]": ["taumek"],
            "[Abs][DuUnpd]": ["taukuk"],
            "[Abs][PlUnpd]": ["taukut"],
            "[Abs][SgUnpd]": ["tauna"],
            "[Equ]": ["tuaten"],
            "[Equ][DuUnpd]": ["taukugcetun"],
            "[Equ][PlUnpd]": ["taukucetun"],
            "[Equ][SgUnpd]": ["tautun"],
            "[Loc]": ["tuani", "tavani"],
            "[Loc][DuUnpd]": ["taukugni"],
            "[Loc][PlUnpd]": ["taukuni"],
            "[Loc][SgUnpd]": ["taumi"],
            "[Rel][DuUnpd]": ["taukuk"],
            "[Rel][PlUnpd]": ["taukut"],
            "[Rel][SgUnpd]": ["taum"],
            "[Sec_Ter]": ["-"],
            "[Ter]": ["tuavet", "tavavet"],
            "[Ter][DuUnpd]": ["taukugnun"],
            "[Ter][PlUnpd]": ["taukunun"],
            "[Ter][SgUnpd]": ["taumun"],
            "[Via]": ["tuaggun", "tavaggun"],
            "[Via][DuUnpd]": ["taukunegnun"],
            "[Via][PlUnpd]": ["taukutgun"],
            "[Via][SgUnpd]": ["taukun"],
            "[Voc][DuUnpd]": ["taukuuk"],
            "[Voc][PlUnpd]": ["taukuut"],
            "[Voc][SgUnpd]": ["tausuuq", "tauyuuq"]
        }
    },
    "up above": {
        "extended": {
            "=i[Encl]": ["pagaa-i", "pii-i"],
            "[Abl]": ["pagaaken", "piiken"],
            "[Abl_Mod][DuUnpd]": ["pagkugnek"],
            "[Abl_Mod][PlUnpd]": ["pagkunek"],
            "[Abl_Mod][SgUnpd]": ["pag'umek"],
            "[Abs][DuUnpd]": ["pagkuk"],
            "[Abs][PlUnpd]": ["pagkut"],
            "[Abs][SgUnpd]": ["pagna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["pagkugcetun"],
            "[Equ][PlUnpd]": ["pagkucetun"],
            "[Equ][SgUnpd]": ["pag'utun"],
            "[Loc]": ["pagaani", "piini"],
            "[Loc][DuUnpd]": ["pagkugni"],
            "[Loc][PlUnpd]": ["pagkuni"],
            "[Loc][SgUnpd]": ["pag'umi"],
            "[Rel][DuUnpd]": ["pagkuk"],
            "[Rel][PlUnpd]": ["pagkut"],
            "[Rel][SgUnpd]": ["pag'um"],
            "[Sec_Ter]": ["pagaatmun", "piitmun"],
            "[Ter]": ["pagaavet", "piivet"],
            "[Ter][DuUnpd]": ["pagkugnun"],
            "[Ter][PlUnpd]": ["pagkunun"],
            "[Ter][SgUnpd]": ["pag'umun"],
            "[Via]": ["pagaaggun", "piiggun"],
            "[Via][DuUnpd]": ["pagkunegnun"],
            "[Via][PlUnpd]": ["pagkutgun"],
            "[Via][SgUnpd]": ["pag'ukun"],
            "[Voc][DuUnpd]": ["pagkuuk"],
            "[Voc][PlUnpd]": ["pagkuut"],
            "[Voc][SgUnpd]": ["pagsuuq", "pagyuuq"]
        },
        "obscured": {
            "=i[Encl]": ["pakma-i"],
            "[Abl]": ["pakmaken"],
            "[Abl_Mod][DuUnpd]": ["pakemkugnek"],
            "[Abl_Mod][PlUnpd]": ["pakemkunek"],
            "[Abl_Mod][SgUnpd]": ["pak'mumek"],
            "[Abs][DuUnpd]": ["pakemkuk"],
            "[Abs][PlUnpd]": ["pakemkut"],
            "[Abs][SgUnpd]": ["pakemna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["pakemkugcetun"],
            "[Equ][PlUnpd]": ["pakemkucetun"],
            "[Equ][SgUnpd]": ["pak'mutun"],
            "[Loc]": ["pakmani"],
            "[Loc][DuUnpd]": ["pakemkugni"],
            "[Loc][PlUnpd]": ["pakemkuni"],
            "[Loc][SgUnpd]": ["pak'mumi"],
            "[Rel][DuUnpd]": ["pakemkuk"],
            "[Rel][PlUnpd]": ["pakemkut"],
            "[Rel][SgUnpd]": ["pak'mum"],
            "[Sec_Ter]": ["-"],
            "[Ter]": ["pakmavet"],
            "[Ter][DuUnpd]": ["pakemkugnun"],
            "[Ter][PlUnpd]": ["pakemkunun"],
            "[Ter][SgUnpd]": ["pak'mumun"],
            "[Via]": ["pakmaggun"],
            "[Via][DuUnpd]": ["pakemkunegnun"],
            "[Via][PlUnpd]": ["pakemkutgun"],
            "[Via][SgUnpd]": ["pak'mukun"],
            "[Voc][DuUnpd]": ["pakemkuuk"],
            "[Voc][PlUnpd]": ["pakemkuut"],
            "[Voc][SgUnpd]": ["pakemsuuq", "pakemyuuq"]
        },
        "restricted": {
            "=i[Encl]": ["pika-i"],
            "[Abl]": ["pikaken"],
            "[Abl_Mod][DuUnpd]": ["pikegkugnek"],
            "[Abl_Mod][PlUnpd]": ["pikegkunek"],
            "[Abl_Mod][SgUnpd]": ["pik'umek", "pikgumek"],
            "[Abs][DuUnpd]": ["pikegkuk"],
            "[Abs][PlUnpd]": ["pikegkut"],
            "[Abs][SgUnpd]": ["pikna", "pikeggna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["pikegkugcetun"],
            "[Equ][PlUnpd]": ["pikegkucetun"],
            "[Equ][SgUnpd]": ["pik'utun", "pikgutun"],
            "[Loc]": ["pikani"],
            "[Loc][DuUnpd]": ["pikegkugni"],
            "[Loc][PlUnpd]": ["pikegkuni"],
            "[Loc][SgUnpd]": ["pik'umi", "pikgumi"],
            "[Rel][DuUnpd]": ["pikegkuk"],
            "[Rel][PlUnpd]": ["pikegkut"],
            "[Rel][SgUnpd]": ["pik'um", "pikgum"],
            "[Sec_Ter]": ["pikatmun"],
            "[Ter]": ["pikavet"],
            "[Ter][DuUnpd]": ["pikegkugnun"],
            "[Ter][PlUnpd]": ["pikegkunun"],
            "[Ter][SgUnpd]": ["pik'umun", "pikgumun"],
            "[Via]": ["pikaggun"],
            "[Via][DuUnpd]": ["pikegkunegnun"],
            "[Via][PlUnpd]": ["pikegkutgun"],
            "[Via][SgUnpd]": ["pik'ukun", "pikgukun"],
            "[Voc][DuUnpd]": ["pikegkuuk"],
            "[Voc][PlUnpd]": ["pikegkuut"],
            "[Voc][SgUnpd]": ["piksuuq", "pikyuuq", "pikeggsuuq","pikeggyuuq"]
        }
    },
    "up the slope": {
        "extended": {
            "=i[Encl]": ["pava-i"],
            "[Abl]": ["pavaken"],
            "[Abl_Mod][DuUnpd]": ["pau͡gkugnek", "paugkugnek"],
            "[Abl_Mod][PlUnpd]": ["pau͡gkunek", "paugkunek"],
            "[Abl_Mod][SgUnpd]": ["pau͡g'umek", "paug'umek"],
            "[Abs][DuUnpd]": ["pau͡gkuk", "paugkuk"],
            "[Abs][PlUnpd]": ["pau͡gkut", "paugkut"],
            "[Abs][SgUnpd]": ["pau͡gna", "paugna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["pau͡gkugcetun", "paugkugcetun"],
            "[Equ][PlUnpd]": ["pau͡gkucetun", "paugkucetun"],
            "[Equ][SgUnpd]": ["pau͡g'utun", "paug'utun"],
            "[Loc]": ["pavani"],
            "[Loc][DuUnpd]": ["pau͡gkugni", "paugkugni"],
            "[Loc][PlUnpd]": ["pau͡gkuni", "paugkuni"],
            "[Loc][SgUnpd]": ["pau͡g'umi", "paug'umi"],
            "[Rel][DuUnpd]": ["pau͡gkuk", "paugkuk"],
            "[Rel][PlUnpd]": ["pau͡gkut", "paugkut"],
            "[Rel][SgUnpd]": ["pau͡g'um", "paug'um"],
            "[Sec_Ter]": ["pavatmun"],
            "[Ter]": ["pavavet"],
            "[Ter][DuUnpd]": ["pau͡gkugnun", "paugkugnun"],
            "[Ter][PlUnpd]": ["pau͡gkunun", "paugkunun"],
            "[Ter][SgUnpd]": ["pau͡g'umun", "paug'umun"],
            "[Via]": ["pavaggun"],
            "[Via][DuUnpd]": ["pau͡gkunegnun", "paugkunegnun"],
            "[Via][PlUnpd]": ["pau͡gkutgun", "paugkutgun"],
            "[Via][SgUnpd]": ["pau͡g'ukun", "paug'ukun"],
            "[Voc][DuUnpd]": ["pau͡gkuuk", "paugkuuk"],
            "[Voc][PlUnpd]": ["pau͡gkuut", "paugkuut"],
            "[Voc][SgUnpd]": ["pau͡gsuuq", "pau͡gyuuq", "paugsuuq", "paugyuuq"]
        },
        "obscured": {
            "=i[Encl]": ["pama-i"],
            "[Abl]": ["pamaken"],
            "[Abl_Mod][DuUnpd]": ["pamkugnek"],
            "[Abl_Mod][PlUnpd]": ["pamkunek"],
            "[Abl_Mod][SgUnpd]": ["pam'umek"],
            "[Abs][DuUnpd]": ["pamkuk"],
            "[Abs][PlUnpd]": ["pamkut"],
            "[Abs][SgUnpd]": ["pamna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["pamkugcetun"],
            "[Equ][PlUnpd]": ["pamkucetun"],
            "[Equ][SgUnpd]": ["pam'utun"],
            "[Loc]": ["pamani"],
            "[Loc][DuUnpd]": ["pamkugni"],
            "[Loc][PlUnpd]": ["pamkuni"],
            "[Loc][SgUnpd]": ["pam'umi"],
            "[Rel][DuUnpd]": ["pamkuk"],
            "[Rel][PlUnpd]": ["pamkut"],
            "[Rel][SgUnpd]": ["pam'um"],
            "[Sec_Ter]": ["-"],
            "[Ter]": ["pamavet"],
            "[Ter][DuUnpd]": ["pamkugnun"],
            "[Ter][PlUnpd]": ["pamkunun"],
            "[Ter][SgUnpd]": ["pam'umun"],
            "[Via]": ["pamaggun"],
            "[Via][DuUnpd]": ["pamkunegnun"],
            "[Via][PlUnpd]": ["pamkutgun"],
            "[Via][SgUnpd]": ["pam'ukun"],
            "[Voc][DuUnpd]": ["pamkuuk"],
            "[Voc][PlUnpd]": ["pamkuut"],
            "[Voc][SgUnpd]": ["pamsuuq", "pamyuuq"]
        },
        "restricted": {
            "=i[Encl]": ["pia-i"],
            "[Abl]": ["piaken"],
            "[Abl_Mod][DuUnpd]": ["pingkugnek"],
            "[Abl_Mod][PlUnpd]": ["pingkunek"],
            "[Abl_Mod][SgUnpd]": ["ping'umek"],
            "[Abs][DuUnpd]": ["pingkuk"],
            "[Abs][PlUnpd]": ["pingkut"],
            "[Abs][SgUnpd]": ["pingna"],
            "[Equ]": ["-"],
            "[Equ][DuUnpd]": ["pingkugcetun"],
            "[Equ][PlUnpd]": ["pingkucetun"],
            "[Equ][SgUnpd]": ["ping'utun"],
            "[Loc]": ["piani"],
            "[Loc][DuUnpd]": ["pingkugni"],
            "[Loc][PlUnpd]": ["pingkuni"],
            "[Loc][SgUnpd]": ["ping'umi"],
            "[Rel][DuUnpd]": ["pingkuk"],
            "[Rel][PlUnpd]": ["pingkut"],
            "[Rel][SgUnpd]": ["ping'um"],
            "[Sec_Ter]": ["piatmun"],
            "[Ter]": ["piavet"],
            "[Ter][DuUnpd]": ["pingkugnun"],
            "[Ter][PlUnpd]": ["pingkunun"],
            "[Ter][SgUnpd]": ["ping'umun"],
            "[Via]": ["piaggun"],
            "[Via][DuUnpd]": ["pingkunegnun"],
            "[Via][PlUnpd]": ["pingkutgun"],
            "[Via][SgUnpd]": ["ping'ukun"],
            "[Voc][DuUnpd]": ["pingkuuk"],
            "[Voc][PlUnpd]": ["pingkuut"],
            "[Voc][SgUnpd]": ["pingsuuq", "pingyuuq"]
        }
    }
};

export const endingToEnglishTerms = {
	"[Ind]":"Indicative (Statement Form)",
	"[Intrg]":"Interrogative (Question Form)",
	"[Opt]":"Optative (Command Form)",
	"[Sbrd]":"Subordinative (Polite Command or -ing Form)",
	"[Ptcp]":"Participial",
	"[Prec]":"Precessive (before...)",
	"[Cnsq]":"Consequential (because...)",
	"[Cont]":"Contigent (whenever...)",
	"[Conc]":"Concessive (although, even though, even if...)",
	"[Cond]":"Conditional (if, when in the future...)",
	"[CtmpI]":"Contemporative 1 (when in fthe past...)",
	"[CtmpII]":"Contemporative 2 (while...)",
	"[Abs]":"Absolutive",
	"[Rel]":"Relative",
	"[Abl_Mod]":"Ablative-Modalis (indirect object, from...)",
	"[Abl]":"Ablative (from...)",
	"[Loc]":"Localis (in, at...)",
	"[Ter]":"Terminalis (to...)",
	"[Sec_Ter]":"Second Terminalis (toward...)",
	"[Via]":"Vialis (through, using...)",
	"[Equ]":"Equalis (like, similar to...)",
	"[Quant_Qual]":"Quantifier/Qualifier Inflection",
	"[Voc]":"Vocative",
	"[Cardinal]":"Cardinal Numeral",
	"[S_3Sg]":"he,\xa0she,\xa0it",
	"[S_3Du]":"they\xa0(2)",
	"[S_3Pl]":"they\xa0all\xa0(3+)",
	"[S_1Sg]":"I",
	"[S_1Du]":"we\xa0(2)",
	"[S_1Pl]":"we\xa0all\xa0(3+)",
	"[S_2Sg]":"you",
	"[S_2Du]":"you\xa0(2)",
	"[S_2Pl]":"you\xa0all\xa0(3+)",
	"[S_4Sg]":"he, she, it (itself)",
	"[S_4Du]":"they (2) (themselves)",
	"[S_4Pl]":"they all (3+) (themselves)",
	"[A_3Sg]":"he,\xa0she,\xa0it",
	"[A_3Du]":"they\xa0(2)",
	"[A_3Pl]":"they\xa0all\xa0(3+)",
	"[A_1Sg]":"I",
	"[A_1Du]":"we\xa0(2)",
	"[A_1Pl]":"we\xa0all\xa0(3+)",
	"[A_2Sg]":"you",
	"[A_2Du]":"you\xa0(2)",
	"[A_2Pl]":"you\xa0all\xa0(3+)",
	"[A_4Sg]":"he, she, it (itself)",
	"[A_4Du]":"they (2) (themselves)",
	"[A_4Pl]":"they all (3+) (themselves)",
//   "[P_3Sg]":"her,\xa0him,\xa0it\xa0(other)",
//   "[P_3Du]":"the\xa0two\xa0of\xa0them\xa0(others)",
//   "[P_3Pl]":"them\xa0all\xa0(3+)\xa0(others)",
	"[P_3Sg]":"another",
	"[P_3Du]":"two others",
	"[P_3Pl]":"3+ others",
	"[P_1Sg]":"me",
	"[P_1Du]":"the\xa0two\xa0of\xa0us",
	"[P_1Pl]":"us\xa0all\xa0(3+)",
	"[P_2Sg]":"you",
	"[P_2Du]":"the\xa0two\xa0of\xa0you",
	"[P_2Pl]":"you\xa0all\xa0(3+)",
	"[P_4Sg]":"her,\xa0him,\xa0it\xa0(itself)",
	"[P_4Du]":"the\xa0two\xa0of\xa0them\xa0(themselves)",
	"[P_4Pl]":"them\xa0all\xa0(3+)\xa0(themselves)",
	"[SgUnpd]":"one",
	"[DuUnpd]":"two",
	"[PlUnpd]":"3+",
	"[SgPosd]":"one",
	"[DuPosd]":"two",
	"[PlPosd]":"3+",
	"[3SgPoss]":"his/her/its\xa0(other)",
	"[3DuPoss]":"their\xa0(2)\xa0(other)",
	"[3PlPoss]":"their\xa0(3+)\xa0(other)",
	"[1SgPoss]":"my",
	"[1DuPoss]":"our\xa0(2)",
	"[1PlPoss]":"our\xa0(3+)",
	"[2SgPoss]":"your\xa0(1)",
	"[2DuPoss]":"your\xa0(2)",
	"[2PlPoss]":"your\xa0(3+)",
	"[4SgPoss]":"his/her/its\xa0own",
	"[4DuPoss]":"their\xa0own\xa0(2)",
	"[4PlPoss]":"their\xa0own\xa0(3+)",
	"[3Sg]":"it\xa0(other)",
	"[3Du]":"them\xa0(2)\xa0(other)",
	"[3Pl]":"them\xa0(3+)\xa0(other)",
	"[1Sg]":"me",
	"[1Du]":"us\xa0(2)",
	"[1Pl]":"us\xa0(3+)",
	"[2Sg]":"you\xa0(1)",
	"[2Du]":"you\xa0(2)",
	"[2Pl]":"you\xa0(3+)",
	"[4Sg]":"itself",
	"[4Du]":"themselves\xa0(2)",
	"[4Pl]":"themselves\xa0(3+)",
	"[Sg]":"one",
	"[Du]":"two",
	"[Pl]":"3+",
};

export const endingEnglishDescriptions = {
	"[Ind]":"(is, are, am)",
	"[Intrg]":"(question)",
	"[Opt]":"(do it!)",
	"[Sbrd]":"(please do, being)",
	"[Ptcp]":"(the one being, special case)",
	"[Prec]":"(before)",
	"[Cnsq]":"(because)",
	"[Cont]":"(whenever)",
	"[Conc]":"(although, even if)",
	"[Cond]":"(if, when in future)",
	"[CtmpI]":"(when in past)",
	"[CtmpII]":"(while)",
	"[Abs]":"the",
	"[Rel]":"the",
	"[Abl_Mod]":"[a, some, from]",
	"[Abl]":"from",
	"[Loc]":"in or at",
	"[Ter]":"to",
	"[Sec_Ter]":"toward",
	"[Via]":"through or using",
	"[Equ]":"like or similar to",
	"[Quant_Qual]":"Quantifier/Qualifier Inflection",
	"[Voc]":"(calling)",
	"[Cardinal]":"",
}

export const endingDescriptions = [
"1) statements; 2) “yes-no” questions, usually with enclitic =qaa",
"1) content questions; 2) exclamations with the postbase @5+pag- | ~vag-",
"1) commands, requests, suggestions; 2) statements in narrative with the postbase ki- and a third person ending",
"1) actions or states subordinate to that of the main verb and involving the same subject; 2) requests, commands, suggestions with a second person ending",
"1) exclamations, usually with tang; 2) certain special constructions (see maaten and =wa)",
"“before”",
"“because”",
"“whenever”",
"“although, even though, even if” ",
"“if, when (in the future)”",
"“when (in the past)” ",
"“while”",
"1) subject of an intransitive verb; 2) object of a transitive verb",
"1) subject of a transitive verb; 2) possessor; 3) “independent relative construction,” see section on roots in Generation Introduction, and Appendix 1, for further information",
"1) place from which, time from which; 2) indefinite object of an intransitive verb; 3) specifying information about a noun within a verb; 4) secondary object especially with verbs of speaking and giving; 5) instrument (only in some dialects)",
"1) place at which, time at which; 2) object of a comparison; 3) with postbase @+paa|~vaa and enclitic =lli in exclamations; 4) formal vocative",
"1) place to which, time to which; 2) subject of an embedded verb",
"1) route; 2) instrument; 3) part of a whole",
"1) comparison; 2) language specification; 3) price specification",
];

export const exampleSentences = [
"1) Pissurtuq. - It is hunting. 2) Maqillruuk-qaa? - Did they two took a steambath?",
"1) Qangvaq ayallrua? - When did he go? Caqatarcit? - What will you do? 2) Caperrnaqvagta. - How difficult it is.",
"1) Neri. - Eat. Taisgu. - Bring it here. 2) Tan'gaurluq qanqili, 'Maurluuq!, naw'un iterciqsia?' - The boy said (literally: let the boy say), 'Grandmother!, through where will I get in?'",
"1) Cukaluni aqvaqurtuq. - She is running quickly. 2) Qantan painqegcaarluku. - Lick your plate clean, please.",
"1) Tang, qavalria. - Look, it's sleeping. 2) Maaten itertua anelria. - I came in; lo and behold, he went out.",
"Ayagpailgan payugeskiu. - Before he leaves, bring him food.",
"Ayaksaituq arenqiapakaan ellalluk. - He hasn’t gone because of this bad weather.",
"Ner'aqami tamuanqegcaalartuq. - Whenever she eats, she chews her food well.",
"Pingraan ayagyugtua. - Even though that's the case, I want to go.",
"Anglirikuni elitnauristen͞guyugtuq. - When he grows up, he wants to be a teacher.",
"Akngirtuq atrallermini. - He got hurt when he was coming down.",
"Ayainanermini igtellruuq. - While he was going, he fell.",
"1) Saskaq kuv'uq. - The glass spilled. 2) Maqaruaq pissullrua. - He hunted the rabbit.",
"1) Angutem quyavikaa. - The man was thankful to her. 2) Ciquyam pania cen̄irtuq. - Ciquyaq's daughter is visiting.",
"1) Elitnaurvigmek utertuq. - She's coming home from the school. 2) Ner'uq akutamek. - She is eating some akutaq. 3) Nutaramek qayaliuq. - He is making a new kayak. 4) Aanama kuuvviaryuucimnek aptaanga. - My mother is asking me whether I want coffee.",
"1) Mermi uitauq. - It is in the water. 2) Aatamni sugtunruunga. - I am taller than my dad. 3) Akertem̄i-lli puqlanirpaa! - How warm the sun is! 4) Elpet angutmi, niicugninga. - You man, listen to me.",
"1) Kipusvigmun piyuaguq. - He's walking to the store. 2) Arnam neresqaa neqa taqukamun. - The woman asks/tells the bear to eat the fish.",
"1) Tumyarakun ayallruuq. - He went by the path. 2) Angyakun ayagtut. - They are going by boat. 3) Qercuallruunga it'gamkun. - I got frostbitten on my feet.",
"1) Aatamegcetun yurartut. - They are dancing like their father. 2) Una Yugtun cauga? - What is this in Yup'ik? 3) Akingqertuq malrugtun. - It is two dollars.",
];


export const accordionTitlesVerbs = [
  "Indicative (it is...)",
  "Interrogative (question)",
  "Optative (do it...)",
  "Subordinative (please do or it being...)",
  "Participial (exclamation or special case)",
  "Precessive (before...)",
  "Consequential (because...)",
  "Contigent (whenever...)",
  "Concessive (although, even though, even if...)",
  "Conditional (if, when in the future...)",
  "Contemporative 1 (when in the past...)",
  "Contemporative 2 (while...)",
  ];
// const accordionTitlesVerbs = [
//   "it is... (indicative)",
//   "question (interrogative)",
//   "do it... (optative)",
//   "please do or it being...(subordinative))",
//   "exclamation or special case (participial)",
//   "before... (precessive)",
//   "because... (consequential)",
//   "whenever... (contingent)",
//   "although, even though, even if... (concessive)",
//   "if, when in the future... (conditional)",
//   "when in the past... (contemporative 1)",
//   "while... (contemporative 2)",
//   ];
// const accordionTitlesVerbs = [
//   "it is... (Indicative)",
//   "question (Interrogative)",
//   "do it... (Optative)",
//   "please do or it being... (Subordinative))",
//   "exclamation or special case (Participial)",
//   "before... (Precessive)",
//   "because... (Consequential)",
//   "whenever... (Contingent)",
//   "although, even though, even if... (Concessive)",
//   "if, when in the future... (Conditional)",
//   "when in the past... (Contemporative 1)",
//   "while... (Contemporative 2)",
//   ];
export const accordionTitlesNouns = [
  "Absolutive (the)",
  "Relative (the)",
  "Ablative-Modalis (a, some, from)",
  "Localis (in, at)",
  "Terminalis (to)",
  "Vialis (through, using)",
  "Equalis (like, similar to)",
  ];
export const accordionTitlesQuantQual = [
  "Absolutive (the)",
  "Relative (the possessor, owner)",
  "Ablative-Modalis (a, some, from)",
  "Localis (in, at)",
  "Terminalis (to)",
  "Vialis (through, using)",
  "Equalis (like, similar to)",
  ];
export const persPronounLabels = ["[Abs]","[Rel]","[Abl_Mod]","[Loc]","[Ter]","[Via]","[Equ]"];

export const persPronounSubjects = [
"[3Sg]",
"[3Du]",
"[3Pl]",
"[1Sg]",
"[1Du]",
"[1Pl]",
"[2Sg]",
"[2Du]",
"[2Pl]",
"[4Sg]",
"[4Du]",
"[4Pl]",
];
export const persPronounsEnglish = [
"it\xa0(other)",
"them\xa0(2)\xa0(other)",
"them\xa0(3+)\xa0(other)",
"me",
"us\xa0(2)",
"us\xa0(3+)",
"you\xa0(1)",
"you\xa0(2)",
"you\xa0(3+)",
"itself",
"themselves\xa0(2)",
"themselves\xa0(3+)",
]
export const demPronounTitles = [
"over there or going away",
"across there",                                                
"up the slope",
"up above",
"inside, inland, or upriver",
"outside",
"down below or down the slope",
"downriver or near the exit",
"here, near speaker",
"there, near listener or in context",                                        
"coming this way",
]
export const demPronounSubjects = [
"[Abs][SgUnpd]",
"[Abs][DuUnpd]",
"[Abs][PlUnpd]",
"[Rel][SgUnpd]",
"[Rel][DuUnpd]",
"[Rel][PlUnpd]",
"[Abl_Mod][SgUnpd]",
"[Abl_Mod][DuUnpd]",
"[Abl_Mod][PlUnpd]",
"[Loc][SgUnpd]",
"[Loc][DuUnpd]",
"[Loc][PlUnpd]",
"[Ter][SgUnpd]",
"[Ter][DuUnpd]",
"[Ter][PlUnpd]",
"[Via][SgUnpd]",
"[Via][DuUnpd]",
"[Via][PlUnpd]",
"[Equ][SgUnpd]",
"[Equ][DuUnpd]",
"[Equ][PlUnpd]",
"[Voc][SgUnpd]",
"[Voc][DuUnpd]",
"[Voc][PlUnpd]",
"",
"[Loc]",
"[Ter]",
"[Sec_Ter]",
"[Abl]",
"[Via]",
"[Equ]",
"=i[Encl]",
]
export const demPronounEnglish = [
"absolutive singular",
"absolutive dual",
"absolutive plural",
"relative singular",
"relative dual",
"relative plural",
"abl-modalis singular",
"abl-modalis dual",
"abl-modalis plural",
"localis singular",
"localis dual",
"localis plural",
"terminalis singular",
"terminalis dual",
"terminalis plural",
"vialis singular",
"vialis dual",
"vialis plural",
"equalis singular",
"equalis dual",
"equalis plural",
"vocative singular",
"vocative dual",
"vocative plural",
"",
"localis",
"terminalis",
"second terminalis",
"ablative",
"vialis",
"equalis",
"predicative",
]

export const moods = ["[Ind]","[Intrg]","[Opt]","[Sbrd]","[Ptcp]","[Prec]","[Cnsq]","[Cont]","[Conc]","[Cond]","[CtmpI]","[CtmpII]","[Abs]","[Rel]","[Abl_Mod]","[Loc]", "[Ter]","[Via]","[Equ]","%5BQuant_Qual%5D","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]",];



// WEBPACK FOOTER //
// ./src/components/constants/endingsConstants.js